import { httpClient } from "../utils/httpClient";

import { INotificationsResponse } from "modules/core/types/res";

export const fetchNotifications = async () => {
  const response = await httpClient.get<INotificationsResponse>("/notifications");

  return response.data;
};

export const markNotificationsAsVisited = async (ids: string[]) => {
  const response = await httpClient.put("/notifications/visit", { ids });

  return response.data;
};

export const markNotificationsAsRead = async (ids: string[]) => {
  const response = await httpClient.put("/notifications/mark_read", { ids });

  return response.data;
};
